import "./siteFooter.css";

import { Link } from "react-router-dom";
import React from "react";
import { useVBTranslation } from "./language";

const SiteFooter = () => {
  const { t } = useVBTranslation();

  return (
    <footer className="vsf-footer">
      <div className="vsf-footer-inner">
        <div className="vsf-col vsf-col-about">
          <div className="vsf-badge">Vyntez Buddy</div>
          <h3>{t("homeHeroTitle")}</h3>
          <p>{t("footerAbout")}</p>

          <div className="vsf-trust-points">
            <span>Trusted provider network</span>
            <span>Category-based discovery</span>
            <span>Secure onboarding journey</span>
          </div>
        </div>

        <div className="vsf-col">
          <h4>{t("footerQuickLinks")}</h4>
          <ul>
            <li><Link to="/">{t("navHome")}</Link></li>
            <li><Link to="/cab-booking">{t("navCabBooking")}</Link></li>
            <li><Link to="/services/home-services">{t("navHomeServices")}</Link></li>
            <li><Link to="/home/provider-services">{t("navProvider")}</Link></li>
          </ul>
        </div>

        <div className="vsf-col">
          <h4>{t("footerPolicies")}</h4>
          <ul>
            <li><Link to="/terms">{t("terms")}</Link></li>
            <li><Link to="/privacy">{t("privacy")}</Link></li>
            <li><Link to="/help">{t("footerHelp")}</Link></li>
            <li><Link to="/contact-us">{t("footerContactUs")}</Link></li>
          </ul>
        </div>

        <div className="vsf-col">
          <h4>Connect</h4>
          <p className="vsf-contact-line">
            <i className="fas fa-envelope" aria-hidden="true"></i> info@vyntezbuddy.com
          </p>
          <p className="vsf-contact-line">
            <i className="fas fa-building" aria-hidden="true"></i>
            <a className="vsf-company-link" href="https://www.vyntez.com" target="_blank" rel="noreferrer">
              Vyntez Solutions Pvt Ltd
            </a>
          </p>
          <small className="vsf-contact-note">Serving customers and providers through one connected platform.</small>
        </div>
      </div>

      <div className="vsf-footer-bottom">
        <p>
          &copy; {new Date().getFullYear()} Vyntez Solutions Pvt Ltd. {t("footerRights")}
        </p>
        <p className="vsf-chat-hint" aria-label="Chat support">
          <i className="fas fa-comments" aria-hidden="true"></i>
        </p>
      </div>
    </footer>
  );
};

export default SiteFooter;
